import { configurationElement, typeDatabase, typeFormValue } from './configurationPropertyUtils';
import { IotDevicesParse } from '../ParseClass/Iotdevices.Parse';
import { ElementParse } from '../ParseClass/Element.Parse';
import {
    arrayIsSet,
    deepClone,
    getOnlyValuesEnum,
    getOnlyValuesEnumNumber,
    objectIsSet,
    ObjectSringAny
} from '../providers/service/global-variables.service';
import { BigBuddyPinWrapper } from "../ParseClass/IoTDeviceConfiguration.Parse";

export enum DataSaveMode {
    NO_SAVE = 0,
    WAIT_FOR_MQTT_UPDATES = 1,
    MINIMUM_DATA_USAGE = 5
}

export enum PossiblesCompileMachinesKeys {
    MODBUS_RTU,
    HTTP,
    MQTT,
    Z_WAVE,
    GPIO,
    VIRTUAL,
    S7
}


export const PossiblesCompileMachines = [
    {
        value: PossiblesCompileMachinesKeys.HTTP,
        traduction: 'HTTP',
        holdKeys: ['model', 'element', 'baseUrl', 'password', 'optionalParameters', 'externalInfo', 'externalCommand']
    },
    {
        value: PossiblesCompileMachinesKeys.MODBUS_RTU,
        traduction: 'Modbus_RTU',
        holdKeys: ['model', 'element', 'modbusId', 'isLittleEndian', 'modbusSerialPort', 'baudRate', 'parity', 'optionalParameters', 'externalInfo', 'externalCommand']
    },
    {
        value: PossiblesCompileMachinesKeys.MQTT,
        traduction: 'MQTT',
        holdKeys: ['model', 'element', 'mqttTopics', 'optionalParameters', 'externalInfo', 'externalCommand']
    },
    {
        value: PossiblesCompileMachinesKeys.Z_WAVE,
        traduction: 'Z_Wave',
        holdKeys: ['model', 'element', 'zwNodeId', 'zwSerialPort', 'optionalParameters', 'externalInfo', 'externalCommand']
    },
    {
        value: PossiblesCompileMachinesKeys.VIRTUAL,
        traduction: 'virtual',
        holdKeys: ['element', 'model', 'optionalParameters', 'externalInfo', 'externalCommand']
    },
    {
        value: PossiblesCompileMachinesKeys.GPIO,
        traduction: 'GPIO',
        holdKeys: ['element', 'model', 'pin', 'inverted', 'functionMode', 'optionalParameters', 'externalInfo', 'externalCommand']
    },
    {
        value: PossiblesCompileMachinesKeys.S7,
        traduction: 'S7',
        holdKeys: ['element', 'model', 's7Host', 's7Rack', 's7Slot', 's7Port', 'optionalParameters', 'externalInfo', 'externalCommand']
    }
]

export enum PossiblesCompileMetersKeys {
    Modbus_RTU,
    MQTT,
}

export const PossiblesCompileMeters = [
    {
        value: PossiblesCompileMetersKeys.Modbus_RTU,
        traduction: 'Modbus_RTU',
        holdKeys: ['model', 'element', 'modbusId', 'modbusSerialPort', 'baudRate', 'parity', 'initialActiveEnergyValue', 'initialReactiveEnergyValue', 'energyType', 'correctionCoefficient', 'isLittleEndian']
    },
    {
        value: PossiblesCompileMetersKeys.MQTT,
        traduction: 'MQTT',
        holdKeys: ['model', 'element', 'mqttTopics', 'initialActiveEnergyValue', 'initialReactiveEnergyValue', 'energyType', 'correctionCoefficient']

    },
]
export const baudratePossibleValues = [
    '1200',
    '2400',
    '4800',
    '9600',
    '19200',
    '38400',
    '57600',
    '115200',
];
export const parityPossibleValues = [
    'none',
    'even',
    'odd',
];
export const serialPortPossibleValues = [
    '/dev/ttyUSB0',
    '/dev/ttyUSB1',
    '/dev/ttyUSB2',
    '/dev/ttyUSB3',
    '/dev/ttyACM0',
    '/dev/ttyACM1',
    '/dev/ttyAMA0',
    '/dev/ttyAMA1',
];

export function getObjByValueInput(key: any, obj: ObjectSringAny): ObjectSringAny {
    let input
    if (key == 'Entrata') {
        input = true
    } else if (key == 'Uscita') {
        input = false
    }
    if (obj == null) {
        obj = { input };
    } else {
        obj['input'] = input;
    }
    return obj;
}

export function getObjByValueDigital(key: any, obj: ObjectSringAny): ObjectSringAny {
    let digital
    if (key == 'Digitale') {
        digital = true
    } else if (key == 'Analagico') {
        digital = false
    }
    if (obj == null) {
        obj = { digital };
    } else {
        obj['digital'] = digital;
    }
    return obj;
}

export function getObjByValueModBus(key: any, obj: ObjectSringAny): ObjectSringAny {
    if (obj == null) {
        obj = { modbusOptions: { baudRate: key } };
    } else if (obj.modbusOptions == null) {
        obj = { ...obj, modbusOptions: { baudRate: key } };
    } else if (obj.modbusOptions.baudRate == null) {
        obj.modbusOptions.baudRate = key;
    }
    return obj;
}

export function getObjByValueParity(key: any, obj: ObjectSringAny): ObjectSringAny {
    if (obj == null) {
        obj = { modbusOptions: { parity: key } };
    } else if (obj.modbusOptions == null) {
        obj = { ...obj, modbusOptions: { parity: key } };
    } else if (obj.modbusOptions.parity == null) {
        obj.modbusOptions.parity = key;
    }
    return obj;
}

export function getValueByObjBaudRate(obj: ObjectSringAny): any {
    if (obj != null && obj.modbusOptions != null && obj.modbusOptions.baudRate != null) {
        return obj.modbusOptions.baudRate;
    } else {
        return null;
    }
}

export function getValueByObjParity(obj: ObjectSringAny): any {
    if (obj != null && obj.modbusOptions != null && obj.modbusOptions.parity != null) {
        return obj.modbusOptions.parity;
    } else {
        return null;
    }
}

export const configurationPropertyMeters: configurationElement[] = [
    {
        keyName: 'comType',
        varianteKey: '',
        traductionKey: 'IotDevices.comType.title',
        group: { key: 'general', traduction: 'IotDevices.groups.general' },
        typeForm: typeFormValue.ELENCO_RADIO_BUTTON,
        typeDatabase: typeDatabase.NUMBER,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: true,
        possibleValues: getOnlyValuesEnumNumber(PossiblesCompileMetersKeys),
        pointer: undefined,
        sortingValue: 50,
        section: 0,
        forms: undefined
    },
    {
        keyName: 'element',
        varianteKey: '',
        traductionKey: 'IotDevices.element',
        group: { key: 'general', traduction: 'IotDevices.groups.general' },
        typeForm: typeFormValue.ELENCO_WITH_FILTER,
        typeDatabase: typeDatabase.STRING,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: true,
        possibleValues: undefined,
        pointer: {
            className: 'Element',
            getValue: (element: ElementParse) => {
                return element.name;
            }
        },
        sortingValue: 100,
        section: 0,
        forms: undefined
    },
    {
        keyName: 'model',
        varianteKey: '',
        traductionKey: 'IotDevices.model',
        group: { key: 'general', traduction: 'IotDevices.groups.general' },
        typeForm: typeFormValue.ELENCO_APERTO,
        typeDatabase: typeDatabase.STRING,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValueIsInVariableComponent: true,
        possibleValues: [
            "ABB-DMTME",
            "ABB-M2M",
            "CONTAX_D-BUS_10093",
            "DISSOLVED_O2_4_20_MA_20PPM_DAT_3017",
            "DIRIS-A-10",
            "DIRIS-A-14",
            "ECA380D",
            "ECR140D",
            "FANCOIL_4QUBINO",
            "GENERIC_4_20MA_OPEN_DAT3024",
            "HUNA_TEMPERATURE_SENSOR_WIFI",
            "HUNA_THERMOSTAT_WIFI_TOUCH",
            "MH7H-WH",
            "MH8-FC4",
            "MH9-CO2",
            "OR-WE-514",
            "OR-WE-516",
            "OR-WE-516-1",
            "OR-WE-516-1-REV",
            "OR-WE-516-2",
            "OR-WE-516-2-REV",
            "OR-WE-516-3",
            "OR-WE-516-3-REV",
            "OR-WE-516-REV",
            "OR-WE-517",
            "OR-WE-517-1",
            "OR-WE-517-1-REV",
            "OR-WE-517-2",
            "OR-WE-517-2-REV",
            "OR-WE-517-3",
            "OR-WE-517-3-REV",
            "OR-WE-517-REV",
            "PLC_SIEMENS",
            "PLC_SIEMENS_V2",
            "PRYCAM_HOME_MONO",
            "PRYCAM_HOME_TRI",
            "PRYSMIAN_TEST_SENSOR",
            "S203RC-D",
            "S203TA-D",
            "SENECA",
            "SHELLY_1_V3",
            "SHELLY_2_5",
            "SHELLY_DUO_BULB",
            "SHELLY_PLUG",
            "SHELLY_PLUG_S",
            "SHELLY_PRO_3EM",
            "SHELLY_QUBINO_WAVE_1",
            "SHELLY_TRV",
            "UPM209"
        ],
        pointer: undefined,
        sortingValue: 200,
        section: 0,
        forms: undefined
    },
    {
        keyName: 'correctionCoefficient',
        varianteKey: '',
        traductionKey: 'IotDevices.correctionCoefficient',
        group: { key: 'energy', traduction: 'IotDevices.groups.energy' },
        typeForm: typeFormValue.INPUT_NUMBER,
        typeDatabase: typeDatabase.NUMBER,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 300,
        section: 0,
        forms: undefined
    },
    {
        keyName: 'initialActiveEnergyValue',
        varianteKey: '',
        traductionKey: 'IotDevices.initialActiveEnergyValue',
        group: { key: 'energy', traduction: 'IotDevices.groups.energy' },
        typeForm: typeFormValue.INPUT_INTEGER,
        typeDatabase: typeDatabase.NUMBER,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 400,
        section: 0,
        forms: undefined
    }, {
        keyName: 'initialReactiveEnergyValue',
        varianteKey: '',
        traductionKey: 'IotDevices.initialReactiveEnergyValue',
        group: { key: 'energy', traduction: 'IotDevices.groups.energy' },
        typeForm: typeFormValue.INPUT_INTEGER,
        typeDatabase: typeDatabase.NUMBER,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 500,
        section: 0,
        forms: undefined
    },
    {
        keyName: 'mqttTopics',
        varianteKey: '',
        traductionKey: 'IotDevices.mqttTopics',
        group: { key: 'mqtt', traduction: 'IotDevices.groups.mqtt' },
        typeForm: typeFormValue.INPUT_ARRAY_TEXTS,
        typeDatabase: typeDatabase.ARRAY,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: true,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 600,
        section: 0,
        forms: undefined
    },
    {
        keyName: 'modbusId',
        varianteKey: '',
        traductionKey: 'IotDevices.modbusId',
        group: { key: 'modbus', traduction: 'IotDevices.groups.modbus' },
        typeForm: typeFormValue.INPUT_INTEGER,
        typeDatabase: typeDatabase.NUMBER,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: true,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 700,
        section: 0,
        forms: undefined
    },
    {
        keyName: 'modbusSerialPort',
        varianteKey: '',
        traductionKey: 'IotDevices.modbusSerialPort',
        group: { key: 'modbus', traduction: 'IotDevices.groups.modbus' },
        typeForm: typeFormValue.ELENCO_APERTO,
        typeDatabase: typeDatabase.STRING,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: serialPortPossibleValues,
        pointer: undefined,
        sortingValue: 800,
        section: 0,
        forms: undefined
    },
    {
        keyName: 'baudRate',
        varianteKey: '',
        traductionKey: 'IotDevices.baudRate',
        group: { key: 'modbus', traduction: 'IotDevices.groups.modbus' },
        typeForm: typeFormValue.ELENCO_APERTO,
        typeDatabase: typeDatabase.NUMBER,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: baudratePossibleValues,
        getObjByValue: (key: string, obj) => {
            return getObjByValueModBus(key, obj);
        },
        getValueByObj: (obj: any) => {
            return getValueByObjBaudRate(obj);
        },
        pointer: undefined,
        sortingValue: 900,
        section: 0,
        forms: undefined
    },
    {
        keyName: 'parity',
        varianteKey: '',
        traductionKey: 'IotDevices.parity',
        group: { key: 'modbus', traduction: 'IotDevices.groups.modbus' },
        typeForm: typeFormValue.ELENCO_APERTO,
        typeDatabase: typeDatabase.STRING,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: parityPossibleValues,
        getObjByValue: (key: string, obj) => {
            return getObjByValueParity(key, obj);
        },
        getValueByObj: (obj: any) => {
            return getValueByObjParity(obj);
        },
        pointer: undefined,
        sortingValue: 1000,
        section: 0,
        forms: undefined
    },
    {
        keyName: 'isLittleEndian',
        varianteKey: '',
        traductionKey: 'IotDevices.isLittleEndian',
        group: { key: 'modbus', traduction: 'IotDevices.groups.modbus' },
        typeForm: typeFormValue.CHECKBOX,
        typeDatabase: typeDatabase.BOOLEAN,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 1000,
        section: 0,
        forms: undefined
    },
    {
        keyName: 'energyType',
        varianteKey: '',
        traductionKey: 'IotDevices.isEnergyProduction',
        group: { key: 'energy', traduction: 'IotDevices.groups.energy' },
        typeForm: typeFormValue.ELENCO_RADIO_BUTTON,
        typeDatabase: typeDatabase.OBJECT,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: true,
        possibleValues: ['Consumo', 'Fotovoltaico', 'Rete', 'Batteria'],
        substituionKeyNameInFormWithObj: (key: string) => {
            const obj: any = {};
            // tslint:disable:triple-equals
            if (key == 'Consumo') {
                obj.isEnergyProduction = false;
            } else if (key == 'Fotovoltaico') {
                obj.isEnergyProduction = true;

            } else if (key == 'Rete') {
                obj.isNetworkEnergy = true;

            } else if (key == 'Batteria') {
                obj.isBatteryOutput = true;
            }
            return obj;
        },
        getPossibleValuesByObject: (obj: any) => {
            let key;
            // tslint:disable:triple-equals
            if (obj.isEnergyProduction == false) {
                key = 'Consumo';
            } else if (obj.isEnergyProduction == true) {
                key = 'Fotovoltaico';
            } else if (obj.isNetworkEnergy == true) {
                key = 'Rete';
            } else if (obj.isBatteryOutput == true) {
                key = 'Batteria';
            }
            return key;
        },
        pointer: undefined,
        sortingValue: 1100,
        section: 0,
        forms: undefined
    },


];
export const configurationPropertyMachines: configurationElement[] = [
    {
        keyName: 'comType',
        varianteKey: '',
        traductionKey: 'IotDevices.comType.title',
        group: { key: 'general', traduction: 'IotDevices.groups.general' },
        typeForm: typeFormValue.ELENCO_RADIO_BUTTON,
        typeDatabase: typeDatabase.NUMBER,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: true,
        possibleValues: getOnlyValuesEnumNumber(PossiblesCompileMachinesKeys),
        pointer: undefined,
        sortingValue: 50,
        section: 0,
        forms: undefined
    },
    {
        keyName: 'model',
        varianteKey: '',
        traductionKey: 'IotDevices.model',
        group: { key: 'general', traduction: 'IotDevices.groups.general' },
        typeForm: typeFormValue.ELENCO_APERTO,
        typeDatabase: typeDatabase.STRING,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: true,
        possibleValues: [
            'SHELLY_TRV',
            'SHELLY_1_V3',
            'SHELLY_2_5',
            'SHELL_PLUS_HT',
            'CALEFFI-CODE-PRO',
            'CLIVET-SPHERA',
            'CLIVET-GAIA',
            'HUNA_TEMPERATURE_SENSOR_WIFI',
            'HUNA_THERMOSTAT_WIFI_TOUCH',
            'MH9-CO2',
            'MH7H-WH',
            'NORD_Q_GAS_METER',
            'PRYCAM_HOME_MONO'
        ],
        possibleValueIsInVariableComponent: true,
        pointer: undefined,
        sortingValue: 100,
        section: 0,
        forms: undefined
    }, {
        keyName: 'modbusId',
        varianteKey: '',
        traductionKey: 'IotDevices.modbusId',
        group: { key: 'modbus', traduction: 'IotDevices.groups.modbus' },
        typeForm: typeFormValue.INPUT_INTEGER,
        typeDatabase: typeDatabase.NUMBER,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: true,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 300,
        section: 0,
        // unsetKeysWhenSetKey: ['baseUrl', 'password', 'zwNodeId'],
        forms: undefined
    }, {
        keyName: 'element',
        varianteKey: '',
        traductionKey: 'IotDevices.element',
        group: { key: 'general', traduction: 'IotDevices.groups.general' },
        typeForm: typeFormValue.ELENCO_WITH_FILTER,
        typeDatabase: typeDatabase.STRING,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: true,
        possibleValues: undefined,
        pointer: {
            className: 'Element',
            getValue: (element: ElementParse) => {
                return element.name;
            }
        },
        sortingValue: 200,
        section: 0,
        forms: undefined
    }, {
        keyName: 'baseUrl',
        varianteKey: '',
        traductionKey: 'IotDevices.baseUrl',
        group: { key: 'http', traduction: 'IotDevices.groups.http' },
        typeForm: typeFormValue.INPUT_TEXT,
        typeDatabase: typeDatabase.STRING,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: true,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 700,
        section: 0,
        // unsetKeysWhenSetKey: ['modbusId', 'zwNodeId', 'parity', 'modbusSerialPort', 'baudRate'],
        forms: undefined
    },
    {
        keyName: 'password',
        varianteKey: '',
        traductionKey: 'IotDevices.password',
        group: { key: 'http', traduction: 'IotDevices.groups.http' },
        typeForm: typeFormValue.INPUT_TEXT,
        typeDatabase: typeDatabase.STRING,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 800,
        section: 0,
        // unsetKeysWhenSetKey: ['modbusId', 'zwNodeId', 'parity', 'modbusSerialPort', 'baudRate'],
        forms: undefined
    }, {
        keyName: 'mqttTopics',
        varianteKey: '',
        traductionKey: 'IotDevices.mqttTopics',
        group: { key: 'mqtt', traduction: 'IotDevices.groups.mqtt' },
        typeForm: typeFormValue.INPUT_ARRAY_TEXTS,
        typeDatabase: typeDatabase.ARRAY,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 800,
        section: 0,
        forms: undefined
    }, {
        keyName: 'modbusSerialPort',
        varianteKey: '',
        traductionKey: 'IotDevices.modbusSerialPort',
        group: { key: 'modbus', traduction: 'IotDevices.groups.modbus' },
        typeForm: typeFormValue.ELENCO_APERTO,
        typeDatabase: typeDatabase.STRING,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: serialPortPossibleValues,
        pointer: undefined,
        sortingValue: 400,
        section: 0,
        // unsetKeysWhenSetKey: ['baseUrl', 'password', 'zwNodeId'],
        forms: undefined
    },
    {
        keyName: 'baudRate',
        varianteKey: '',
        traductionKey: 'IotDevices.baudRate',
        group: { key: 'modbus', traduction: 'IotDevices.groups.modbus' },
        typeForm: typeFormValue.ELENCO_APERTO,
        typeDatabase: typeDatabase.NUMBER,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: baudratePossibleValues,
        getObjByValue: (key: string, obj) => {
            return getObjByValueModBus(key, obj);
        },
        getValueByObj: (obj: any) => {
            return getValueByObjBaudRate(obj);
        },
        pointer: undefined,
        sortingValue: 500,
        section: 0,
        // unsetKeysWhenSetKey: ['baseUrl', 'password', 'zwNodeId'],
        forms: undefined
    },
    {
        keyName: 'parity',
        varianteKey: '',
        traductionKey: 'IotDevices.parity',
        group: { key: 'modbus', traduction: 'IotDevices.groups.modbus' },
        typeForm: typeFormValue.ELENCO_APERTO,
        typeDatabase: typeDatabase.STRING,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: parityPossibleValues,
        getObjByValue: (key: string, obj) => {
            return getObjByValueParity(key, obj);
        },
        getValueByObj: (obj: any) => {
            return getValueByObjParity(obj);
        },
        pointer: undefined,
        sortingValue: 600,
        section: 0,
        // unsetKeysWhenSetKey: ['baseUrl', 'password', 'zwNodeId'],
        forms: undefined
    },
    {
        keyName: 'isLittleEndian',
        varianteKey: '',
        traductionKey: 'IotDevices.isLittleEndian',
        group: { key: 'modbus', traduction: 'IotDevices.groups.modbus' },
        typeForm: typeFormValue.CHECKBOX,
        typeDatabase: typeDatabase.BOOLEAN,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 650,
        section: 0,
        forms: undefined
    },
    {
        keyName: 'zwNodeId',
        varianteKey: '',
        traductionKey: 'IotDevices.zwNodeId',
        group: { key: 'zwave', traduction: 'IotDevices.groups.zwave' },
        typeForm: typeFormValue.INPUT_INTEGER,
        typeDatabase: typeDatabase.NUMBER,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: true,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 900,
        section: 0,
        // unsetKeysWhenSetKey: ['baseUrl', 'password', 'modbusId', 'parity', 'modbusSerialPort', 'baudRate'],
        forms: undefined
    }, {
        keyName: 'optionalParameters',
        varianteKey: '',
        traductionKey: 'IotDevices.optionalParameters',
        group: { key: 'optionalParameters', traduction: 'IotDevices.groups.optionalParameters' },
        typeForm: typeFormValue.INPUT_KEY_VALUES,
        typeDatabase: typeDatabase.OBJECT,
        getValueByObj: (obj: any) => {
            if (obj && obj.optionalParameters && (obj.optionalParameters.externalInfo || obj.optionalParameters.externalCommand)) {
                const optionalParameters = deepClone(obj.optionalParameters)
                delete optionalParameters?.externalInfo
                delete optionalParameters?.externalCommand

                return optionalParameters
            } else if (obj && obj.optionalParameters) {
                const optionalParameters = deepClone(obj.optionalParameters)
                return optionalParameters
            }
        },
        getObjByValue: (value, obj: any) => {
            const values = deepClone(obj)
            if (objectIsSet(value)) {
                if (values.optionalParameters == null) {
                    values.optionalParameters = {}
                }
                Object.keys(value).forEach(key => {
                    if (key !== 'externalInfo' && key !== 'externalCommand') {
                        values.optionalParameters[key] = value[key]
                    }
                })
            }

            return values ?? obj
        },
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 1100,
        section: 0,
        // unsetKeysWhenSetKey: ['baseUrl', 'password', 'modbusId', 'parity', 'modbusSerialPort', 'baudRate'],
        forms: undefined
    }, {
        keyName: 'externalInfo',
        varianteKey: '',
        traductionKey: 'IotDevices.externalInfo',
        group: { key: 'externalInfo', traduction: 'IotDevices.groups.externalInfo' },
        typeForm: typeFormValue.EXTERNAL_INFO,
        typeDatabase: typeDatabase.OBJECT,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        getValueByObj: (obj: any) => {
            if (obj && obj.optionalParameters && obj.optionalParameters.externalInfo) {
                return obj.optionalParameters.externalInfo
            }
        },
        getObjByValue: (value, obj: any) => {
            const values = deepClone(obj)
            if (arrayIsSet(value)) {
                if (values.optionalParameters == null) {
                    values.optionalParameters = {}
                }
                values.optionalParameters['externalInfo'] = value.map((v: any) => v.toJSON != null ? v.toJSON() : v)
            }
            return values ?? obj
        },
        pointer: undefined,
        sortingValue: 1000,
        section: 0,
        // unsetKeysWhenSetKey: ['baseUrl', 'password', 'modbusId', 'parity', 'modbusSerialPort', 'baudRate'],
        forms: undefined
    },
    {
        keyName: 'externalCommand',
        varianteKey: '',
        traductionKey: 'IotDevices.externalCommand',
        group: { key: 'externalCommand', traduction: 'IotDevices.groups.externalCommand' },
        typeForm: typeFormValue.EXTERNAL_COMMAND,
        typeDatabase: typeDatabase.OBJECT,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        getValueByObj: (obj: any) => {
            if (obj && obj.optionalParameters && obj.optionalParameters.externalCommand) {
                return obj.optionalParameters.externalCommand
            }
        },
        getObjByValue: (value, obj: any) => {
            const values = deepClone(obj)
            if (objectIsSet(value)) {
                if (values.optionalParameters == null) {
                    values.optionalParameters = {}
                }
                values.optionalParameters['externalCommand'] = value
            }
            return values ?? obj
        },
        pointer: undefined,
        sortingValue: 1201,
        section: 0,
        // unsetKeysWhenSetKey: ['baseUrl', 'password', 'modbusId', 'parity', 'modbusSerialPort', 'baudRate'],
        forms: undefined
    },
    {
        keyName: 'pin',
        varianteKey: '',
        traductionKey: 'IotDevices.pin',
        group: { key: 'gpio', traduction: 'IotDevices.groups.gpio' },
        typeForm: typeFormValue.INPUT_INTEGER,
        typeDatabase: typeDatabase.NUMBER,
        getPossibleValuesByObject: (objValue) => {
            if (objValue && objValue.pin != null) {
                return objValue.model == 'GPIO_GENERIC' ? objValue.pin.toString() : objValue.pin
            }
            return undefined
        },
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 950,
        section: 0,
        forms: undefined
    }, {
        keyName: 'input',
        varianteKey: '',
        traductionKey: 'IotDevices.input',
        group: { key: 'gpio', traduction: 'IotDevices.groups.gpio' },
        typeForm: typeFormValue.ELENCO_RADIO_BUTTON,
        typeDatabase: typeDatabase.BOOLEAN,
        editable: true,
        getObjByValue: getObjByValueInput,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: true,
        possibleValues: ['Entrata', 'Uscita'],
        getPossibleValuesByObject: (objValue) => {
            if (objValue) {
                if (objValue.input) {
                    return 'Entrata'
                } else if (objValue.input == false) {
                    return 'Uscita'
                }
            }
            return undefined
        },
        pointer: undefined,
        sortingValue: 900,
        section: 0,
        forms: undefined
    }, {
        keyName: 'auxPin',
        varianteKey: '',
        traductionKey: 'IotDevices.auxPin',
        group: { key: 'gpio', traduction: 'IotDevices.groups.gpio' },
        typeForm: typeFormValue.INPUT_INTEGER,
        typeDatabase: typeDatabase.NUMBER,
        editable: true,
        // getObjByValue: getObjByValueInput,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 900,
        section: 0,
        forms: undefined
    }, {
        keyName: 'digital',
        varianteKey: '',
        traductionKey: 'IotDevices.digital',
        group: { key: 'gpio', traduction: 'IotDevices.groups.gpio' },
        typeForm: typeFormValue.ELENCO_RADIO_BUTTON,
        typeDatabase: typeDatabase.BOOLEAN,
        editable: true,
        showInForm: true,
        filtrable: true,
        getObjByValue: getObjByValueDigital,
        getPossibleValuesByObject: (objValue) => {
            if (objValue) {
                if (objValue.digital == true) {
                    return 'Digitale'
                } else if (objValue.digital == false) {
                    return 'Analagico'
                }
            }
            return undefined
        },
        copyable: false,
        required: true,
        possibleValues: ['Digitale', 'Analagico'],
        pointer: undefined,
        sortingValue: 900,
        section: 0,
        forms: undefined
    }, {
        keyName: 'functionMode',
        varianteKey: '',
        traductionKey: 'IotDevices.functionMode',
        group: { key: 'gpio', traduction: 'IotDevices.groups.gpio' },
        typeForm: typeFormValue.ELENCO_RADIO_BUTTON,
        typeDatabase: typeDatabase.NUMBER,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        getObjByValue: (key: any, obj: ObjectSringAny) => {
            const functionMode = BigBuddyPinWrapper.getFunctionModeValueByName(key)
            if (obj == null) {
                obj = { functionMode }
            } else {
                obj['functionMode'] = functionMode
            }
            return obj;
        },
        getPossibleValuesByObject: (objValue) => {
            if (objValue && objValue.functionMode != null) {
                return objValue.functionMode.toString()
            }
            return undefined
        },
        pointer: undefined,
        sortingValue: 970,
        section: 0,
        forms: undefined
    },
    {
        keyName: 'inverted',
        varianteKey: '',
        traductionKey: 'IotDevices.inverted',
        group: { key: 'gpio', traduction: 'IotDevices.groups.gpio' },
        typeForm: typeFormValue.ONOFFBUTTON,
        typeDatabase: typeDatabase.BOOLEAN,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 950,
        section: 0,
        forms: undefined
    }, {
        keyName: 's7Host',
        varianteKey: '',
        traductionKey: 'IotDevices.s7host',
        group: { key: 's7', traduction: 'IotDevices.groups.s7' },
        typeForm: typeFormValue.INPUT_TEXT,
        typeDatabase: typeDatabase.STRING,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: true,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 700,
        section: 0,
        // unsetKeysWhenSetKey: ['modbusId', 'zwNodeId', 'parity', 'modbusSerialPort', 'baudRate'],
        forms: undefined
    },
    {
        keyName: 's7Port',
        varianteKey: '',
        traductionKey: 'IotDevices.s7port',
        group: { key: 's7', traduction: 'IotDevices.groups.s7' },
        typeForm: typeFormValue.INPUT_NUMBER,
        typeDatabase: typeDatabase.NUMBER,
        formOptions: {
            min: 1,
            max: 65535
        },
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: true,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 700,
        section: 0,
        // unsetKeysWhenSetKey: ['modbusId', 'zwNodeId', 'parity', 'modbusSerialPort', 'baudRate'],
        forms: undefined
    },
    {
        keyName: 's7Rack',
        varianteKey: '',
        traductionKey: 'IotDevices.s7rack',
        group: { key: 's7', traduction: 'IotDevices.groups.s7' },
        typeForm: typeFormValue.INPUT_NUMBER,
        typeDatabase: typeDatabase.NUMBER,
        formOptions: {
            min: 0,
            max: 7
        },
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: true,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 700,
        section: 0,
        // unsetKeysWhenSetKey: ['modbusId', 'zwNodeId', 'parity', 'modbusSerialPort', 'baudRate'],
        forms: undefined
    },
    {
        keyName: 's7Slot',
        varianteKey: '',
        traductionKey: 'IotDevices.s7slot',
        group: { key: 's7', traduction: 'IotDevices.groups.s7' },
        typeForm: typeFormValue.INPUT_NUMBER,
        typeDatabase: typeDatabase.NUMBER,
        formOptions: {
            min: 0,
            max: 31
        },
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: true,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 700,
        section: 0,
        // unsetKeysWhenSetKey: ['modbusId', 'zwNodeId', 'parity', 'modbusSerialPort', 'baudRate'],
        forms: undefined
    },
];


export const configurationPropertyModBusOption: configurationElement[] = [

    {
        keyName: 'zwSerialPort',
        varianteKey: '',
        traductionKey: 'IotDevices.zwSerialPort',
        group: { key: 'zwave', traduction: 'IotDevices.groups.zwave' },
        typeForm: typeFormValue.ELENCO_APERTO,
        typeDatabase: typeDatabase.STRING,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: serialPortPossibleValues,
        pointer: undefined,
        sortingValue: 100,
        section: 0,
        forms: undefined
    },
    {
        keyName: 'mqttUsername',
        varianteKey: '',
        traductionKey: 'IotDevices.mqttUsername',
        group: { key: 'mqttBroker', traduction: 'IotDevices.groups.mqttBroker' },
        typeForm: typeFormValue.INPUT_TEXT,
        typeDatabase: typeDatabase.STRING,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 200,
        section: 0,
        forms: undefined
    }, {
        keyName: 'mqttPassword',
        varianteKey: '',
        traductionKey: 'IotDevices.mqttPassword',
        group: { key: 'mqttBroker', traduction: 'IotDevices.groups.mqttBroker' },
        typeForm: typeFormValue.INPUT_TEXT,
        typeDatabase: typeDatabase.STRING,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 300,
        section: 0,
        forms: undefined
    }, {
        keyName: 'mqttAddress',
        varianteKey: '',
        traductionKey: 'IotDevices.mqttAddress',
        group: { key: 'mqttBroker', traduction: 'IotDevices.groups.mqttBroker' },
        typeForm: typeFormValue.INPUT_TEXT,
        typeDatabase: typeDatabase.STRING,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 400,
        section: 0,
        forms: undefined
    }, {
        keyName: 'mqttPort',
        varianteKey: '',
        traductionKey: 'IotDevices.mqttPort',
        group: { key: 'mqttBroker', traduction: 'IotDevices.groups.mqttBroker' },
        typeForm: typeFormValue.INPUT_INTEGER,
        typeDatabase: typeDatabase.NUMBER,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 500,
        section: 0,
        forms: undefined
    }, {
        keyName: 'mqttProtocol',
        varianteKey: '',
        traductionKey: 'IotDevices.mqttProtocol',
        group: { key: 'mqttBroker', traduction: 'IotDevices.groups.mqttBroker' },
        typeForm: typeFormValue.INPUT_TEXT,
        typeDatabase: typeDatabase.STRING,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 600,
        section: 0,
        forms: undefined
    }, {
        keyName: 'maxSecondsBetweenSensorDataSubmissions',
        varianteKey: '',
        traductionKey: 'IotDevices.maxSecondsBetweenSensorDataSubmissions',
        group: { key: 'dataSubmission', traduction: 'IotDevices.groups.dataSubmission' },
        typeForm: typeFormValue.INPUT_NUMBER,
        typeDatabase: typeDatabase.NUMBER,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 600,
        section: 0,
        forms: undefined
    }, {
        keyName: 'minSecondsBetweenSensorDataSubmissions',
        varianteKey: '',
        traductionKey: 'IotDevices.minSecondsBetweenSensorDataSubmissions',
        group: { key: 'dataSubmission', traduction: 'IotDevices.groups.dataSubmission' },
        typeForm: typeFormValue.INPUT_NUMBER,
        typeDatabase: typeDatabase.NUMBER,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 600,
        section: 0,
        forms: undefined
    }, {
        keyName: 'dataSaveMode',
        varianteKey: '',
        traductionKey: 'IotDevices.dataSaveMode.title',
        group: { key: 'dataSubmission', traduction: 'IotDevices.groups.dataSubmission' },
        typeForm: typeFormValue.ELENCO_VINCOLATO,
        typeDatabase: typeDatabase.NUMBER,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: getOnlyValuesEnum(DataSaveMode),
        possibleValuesTraduction: (v: number) => 'IotDevices.dataSaveMode.' + v,
        getValueToSave: (value: any) => {
            if (typeof value == "number") {
                return value
            } else if (!isNaN(parseInt(value))) {
                return parseInt(value)
            } else {
                return value
            }
        },
        pointer: undefined,
        sortingValue: 600,
        section: 0,
        forms: undefined
    },
    {
        keyName: 'gpsSerialPort',
        varianteKey: '',
        traductionKey: 'IotDevices.gpsSerialPort',
        group: { key: 'gps', traduction: 'IotDevices.groups.gps' },
        typeForm: typeFormValue.ELENCO_APERTO,
        typeDatabase: typeDatabase.STRING,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: serialPortPossibleValues,
        pointer: undefined,
        sortingValue: 700,
        section: 0,
        forms: undefined
    }, {
        keyName: 'gpsBaudrate',
        varianteKey: '',
        traductionKey: 'IotDevices.gpsBaudrate',
        group: { key: 'gps', traduction: 'IotDevices.groups.gps' },
        typeForm: typeFormValue.ELENCO_APERTO,
        typeDatabase: typeDatabase.STRING,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: baudratePossibleValues,
        pointer: undefined,
        sortingValue: 800,
        section: 0,
        forms: undefined
    }, {
        keyName: 'mqttSnapshot',
        varianteKey: '',
        traductionKey: 'IotDevices.mqttSnapshot',
        group: { key: 'system', traduction: 'IotDevices.groups.system' },
        typeForm: typeFormValue.CHECKBOX,
        typeDatabase: typeDatabase.BOOLEAN,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 900,
        section: 0,
        forms: undefined
    }, {
        keyName: 'rebootWhenOffline',
        varianteKey: '',
        traductionKey: 'IotDevices.rebootWhenOffline',
        group: { key: 'system', traduction: 'IotDevices.groups.system' },
        typeForm: typeFormValue.CHECKBOX,
        typeDatabase: typeDatabase.BOOLEAN,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 900,
        section: 0,
        forms: undefined
    }, {
        keyName: 'activateLogtailLogs',
        varianteKey: '',
        traductionKey: 'IotDevices.activateLogtailLogs',
        group: { key: 'system', traduction: 'IotDevices.groups.system' },
        typeForm: typeFormValue.CHECKBOX,
        typeDatabase: typeDatabase.BOOLEAN,
        editable: true,
        showInForm: true,
        filtrable: true,
        copyable: false,
        required: false,
        possibleValues: undefined,
        pointer: undefined,
        sortingValue: 1000,
        section: 0,
        forms: undefined
    },
];


export const configurationPropertyElementParse: configurationElement[] =
    [
        {
            keyName: 'createdAt',
            varianteKey: '',
            traductionKey: 'createdAt',
            typeForm: typeFormValue.DATE,
            typeDatabase: typeDatabase.DATE,
            editable: false,
            showInForm: false,
            filtrable: true,
            copyable: false,
            required: false,
            possibleValues: undefined,
            pointer: undefined,
            sortingValue: 200,
            section: 0,
            forms: undefined
        },
        {
            keyName: 'updatedAt',
            varianteKey: '',
            traductionKey: 'updatedAt',
            typeForm: typeFormValue.DATE,
            typeDatabase: typeDatabase.DATE,
            editable: false,
            showInForm: false,
            filtrable: true,
            copyable: false,
            required: false,
            possibleValues: undefined,
            pointer: undefined,
            sortingValue: 300,
            section: 0,
            forms: undefined
        },

        {
            keyName: 'device',
            varianteKey: undefined,
            traductionKey: 'iotDevices.device',
            typeForm: typeFormValue.ELENCO_APERTO,
            typeDatabase: typeDatabase.POINTER,
            editable: true,
            showInForm: true,
            filtrable: true,
            copyable: false,
            required: false,
            possibleValues: undefined,
            sortingValue: 600,
            section: 0,
            forms: undefined,
            pointer: {
                className: IotDevicesParse.CLASS_NAME,
                getValue: (element: IotDevicesParse) => {
                    return element.type;
                }
            }
        },

    ];
//     {
//     keyName: 'tipologia',
//     varianteKey: undefined,
//     traductionKey: 'tipologia',
//     typeForm: typeFormValue.ELENCO_APERTO,
//     typeDatabase: typeDatabase.STRING,
//     editable: true,
//     showInForm: true,
//     filtrable: true,
//     copyable: true,
//     required: false,
//     possibleValues: [
//         "attraversamentoPedonale"
//         , "bikeSharing"
//         , "cassonetto"
//         , "cestino"
//         , "colonnineRicaricaElettrica"
//         , "dissuasore"
//         , "dosso"
//         , "fermataBus"
//         , "fermataTaxi"
//         , "fermataTram"
//         , "fontana"
//         , "fotoZona"
//         , "panchina"
//         , "parcoGiochi"
//         , "parcometro"
//         , "rastrelliera"
//         , "segnaleStradale"
//         , "semaforo"
//         , "telecamera"
//         , "tombino"
//     ],
//     pointer: undefined,
//     sortingValue: 600,
//     section: 0,
//     forms: {
//         databaseKey: 'detail',
//         values: {
//             attraversamentoPedonale: typeArredoUrbanoValueForm.attraversamentoPedonale_colonnineRicaricaElettrica,
//             colonnineRicaricaElettrica: typeArredoUrbanoValueForm.attraversamentoPedonale_colonnineRicaricaElettrica
//         }
//     }
// }
